// extracted by mini-css-extract-plugin
module.exports = {"tile":"PartnerTile_tile__zhDM0","tile__icon-wrapper":"PartnerTile_tile__icon-wrapper__1fBJM"};